/**
 * 이사 품목 스펙 편집(EditShell / 열 카드)용 표면 스타일.
 *
 * 사이드바(LG.sidebar)와 같이 유리 층은 바깥 한 겹에 두고, 편집 본문은 얕은 틴트+보더만 사용한다.
 */
import type { SxProps, Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';

export function movingItemEditShellSx(theme: Theme): SxProps<Theme> {
  const isDark = theme.palette.mode === 'dark';
  return {
    borderRadius: 2,
    border: `1px solid ${alpha(theme.palette.divider, isDark ? 0.45 : 1)}`,
    backgroundColor: alpha(theme.palette.background.paper, isDark ? 0.38 : 0.5),
    boxShadow: 'none',
    p: 2,
  };
}

/** AttrDefEditor 좌·우 열 (ColumnAttributes / ColumnRules) */
export function movingItemEditorColumnCardSx(theme: Theme): SxProps<Theme> {
  const isDark = theme.palette.mode === 'dark';
  return {
    backgroundColor: alpha(theme.palette.background.paper, isDark ? 0.42 : 0.58),
    border: `1px solid ${alpha(theme.palette.divider, isDark ? 0.45 : 1)}`,
    borderRadius: 2,
    boxShadow: 'none',
    p: 1.5,
    minWidth: 0,
  };
}

/** DisplayNameBlock 등 스펙 단위 하위 카드 */
export function movingItemDisplayNameBlockSx(theme: Theme): SxProps<Theme> {
  return movingItemEditorColumnCardSx(theme);
}
